import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AccordionContext from './../accordion.context';
import { ReactComponent as ContentIcAdd24px } from '../../../assets/icons/content/ic_add_24px.svg';
import { ReactComponent as ContentIcRemove24px } from '../../../assets/icons/content/ic_remove_24px.svg';
import { ReactComponent as ContentIcExpandLess24px } from '../../../assets/icons/navigation/ic_expand_less_24px.svg';
import { ReactComponent as ContentIcExpandMore24px } from '../../../assets/icons/navigation/ic_expand_more_24px.svg';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop  {string} [className]
 * @prop {{}} [triggerButtonProps]
 * @prop {{collapse: React.ReactNode, expand: React.ReactNode}} [icons]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifAccordionTrigger = (props) => {
  const { children, className = '', triggerButtonProps = {}, icons = {}, ...other } = props;
  const { toggleAccordion, useChevronIcon, visible } = useContext(AccordionContext);

  const classes = classNames({
    'motif-accordion-trigger': true,
    [className]: true
  });

  let collapseIcon = icons.collapse;
  let expandIcon = icons.expand;

  if (useChevronIcon) {
    collapseIcon = collapseIcon || <ContentIcExpandLess24px className="motif-accordion-collapse-icon" />;
    expandIcon = expandIcon || <ContentIcExpandMore24px className="motif-accordion-expand-icon" />;
  } else {
    collapseIcon = collapseIcon || <ContentIcRemove24px className="motif-accordion-collapse-icon" />;
    expandIcon = expandIcon || <ContentIcAdd24px className="motif-accordion-expand-icon" />;
  }

  return (
    <button
      type="button"
      onClick={toggleAccordion}
      className={classes}
      data-testid="accordion-button"
      aria-expanded={visible}
      {...triggerButtonProps}
    >
      <div className="motif-accordion-icons">
        {expandIcon}
        {collapseIcon}
      </div>
      <div className="motif-accordion-title-content" {...other}>
        {children}
      </div>
    </button>
  );
};

MotifAccordionTrigger.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icons: PropTypes.shape({
    collapse: PropTypes.node,
    expand: PropTypes.node
  }),
  triggerButtonProps: PropTypes.instanceOf(Object)
};

export { MotifAccordionTrigger };
